import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { colors, darkColors } from '../utils/colors';

type ThemeMode = 'light' | 'dark' | 'system';
type ColorScheme = typeof colors | typeof darkColors;

interface ThemeState {
  mode: ThemeMode;
  colors: ColorScheme;
  setTheme: (mode: ThemeMode) => void;
  isDark: () => boolean;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: 'dark',
      colors: darkColors,
      
      setTheme: (mode: ThemeMode) => {
        const isDarkMode = mode === 'dark' || (mode === 'system' && false); // TODO: システム設定取得
        set({
          mode,
          colors: isDarkMode ? darkColors : colors,
        });
      },

      isDark: () => {
        const state = get();
        return state.mode === 'dark' || (state.mode === 'system' && false);
      },
    }),
    {
      name: 'theme-storage',
      storage: createJSONStorage(() => AsyncStorage),
    }
  )
);
